import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const AssessmentTypeService = {
  listAssessmentTypes: async () => api.get(API_ENDPOINTS.ASSESSMENT_TYPE.LIST),

  getAssessmentType: async (code) => {
    const endpoint = createEndpoint(API_ENDPOINTS.ASSESSMENT_TYPE.GET, {
      code,
    });
    return api.get(endpoint);
  },

  createAssessmentType: async (data) =>
    api.post(API_ENDPOINTS.ASSESSMENT_TYPE.CREATE, data),

  updateAssessmentType: async (code, data) => {
    const endpoint = createEndpoint(API_ENDPOINTS.ASSESSMENT_TYPE.UPDATE, {
      code,
    });
    return api.patch(endpoint, data);
  },

  deleteAssessmentType: async (code) => {
    const endpoint = createEndpoint(API_ENDPOINTS.ASSESSMENT_TYPE.DELETE, {
      code,
    });
    return api.delete(endpoint);
  },
};
